import { useFeatureFlag } from '../../../../hooks/useFeatureFlag'
import { useModulePermission } from '../../../../hooks/useModulePermission'

/**
 * Combined access gate for the Deal Team Aggregation Portal on the client app.
 *
 * Returns `isAuthorized = true` only when both of the following hold:
 *   1. The `dealteam_module_enabled` feature flag is enabled for the org.
 *   2. The signed-in user is a Deal Team module admin (the sidebar entry
 *      with id 'dealteam' is present, which is server-driven by
 *      `isDealTeamModuleAdmin`).
 *
 * Pages should render `<SpinnerWithBackground />` while `isLoading` is true
 * to avoid flashing the "denied" state during initial load. When `isLoading`
 * resolves to false and `isAuthorized` is false, redirect to `/dashboard`.
 */
export function useDealTeamAccess(): { isAuthorized: boolean; isLoading: boolean } {
	const flag = useFeatureFlag('dealteam_module_enabled')
	const perm = useModulePermission('dealteam')

	const isLoading = flag.isLoading || perm.isLoading
	const isAuthorized = !isLoading && flag.isEnabled && perm.isAuthorized

	return { isAuthorized, isLoading }
}
